import React, { Component } from 'react';
import { Layout } from 'app/components/base/Layout';
import LoadingSpinner from 'app/components/base/LoadingSpinner';
import StandardInput from 'app/components/base/StandardInput';
import classnames from 'classnames';
import EmptySuggestions from '../commons/EmptySuggestions';
import SuggestionsList from '../commons/SuggestionsList';
import builder from '../builder';
import _ from 'lodash';

import style from '../style.css';


/**
 * Stateless component for using in mobile autocomplete screens.
 * It uses an interface to be used in `Field` component from `redux-form`.
 * With `Field` you will controll search input field.
 *
 * It provides a prop for working with found items: `items` and `onSelect`.
 * `items` should be an array of objects `{ display, icon: { name, family }, ... }`.
 * `onSelect` called when some item from result is clicked with the item object.
 *
 * You can show loading spinner by passing `loading` prop to the component.
 * @return {Component}
 */
export class MobileBaseAutocomplete extends Component {

  componentDidMount() {
    // wait until animation ends
    setTimeout(() => this.inputDOM.focus(), 100);
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.validated && this.props.validated) {
      this.props.onSelect();
    }
  }

  selectCurrentValue = () => {
    this.props.onSelect();
  }

  renderContent() {
    const {
      emptySuggestions,
      unsafe,
      type,
      selectedSuggestion,
      emptySuggestionsText,
      resultsTitle,
      suggestions,
      onSelect,
      loading,
      input
    } = this.props;

    // Render empty suggestions
    if (emptySuggestions && !unsafe) {
      return <EmptySuggestions text={emptySuggestionsText} />;
    }

    // Render the suggestions list
    if (loading) {
      return <LoadingSpinner size="small" className={style.loading} />;
    }
    return (
      <SuggestionsList
        type={type}
        showAll
        selected={selectedSuggestion}
        title={resultsTitle}
        suggestions={suggestions}
        onSelect={onSelect}
        unsafe={unsafe}
        value={input.value}
      />
    );
  }

  render() {
    const {
      className,
      loading, // eslint-disable-line
      suggestions, // eslint-disable-line
      inputIcon,
      resultsTitle, // eslint-disable-line
      emptySuggestions, // eslint-disable-line
      selectedSuggestion, // eslint-disable-line
      onSelect, // eslint-disable-line
      type, // eslint-disable-line
      unsafe, // eslint-disable-line
      emptySuggestionsText, // eslint-disable-line
      input,
      ...props
    } = this.props;

    return (
      <Layout
        nowrap
        size="noshrink"
        direction="column"
        className={classnames(className, style.container)}
      >
        <StandardInput
          refInput={c => this.inputDOM = c}
          {...props}
          input={{
            ...input,
            onBlur: _.noop
          }}
          className={classnames(style.input, style['input--mobile'])}
          icon={inputIcon}
          type="text"
          uppercase
          nolabel
          cleanable
          mobile
          borderless
        />
        {this.renderContent()}
      </Layout>
    );
  }
}

// TODO: move to Flow types
// MobileBaseAutocomplete.propTypes = {
//   type: PropTypes.string,
//   selectedSuggestion: PropTypes.any,
//   className: PropTypes.string,
//   loading: PropTypes.bool,
//   validated: PropTypes.bool,
//   input: PropTypes.object,
//   suggestions: PropTypes.array,
//   emptySuggestions: PropTypes.bool,
//   onClick: PropTypes.func,
//   onSelect: PropTypes.func,
//   unsafe: PropTypes.bool,
//   inputIcon: PropTypes.any,
//   emptySuggestionsText: PropTypes.string,
//   resultsTitle: PropTypes.oneOfType([
//     PropTypes.node,
//     PropTypes.string
//   ])
// };

export default builder(MobileBaseAutocomplete);
